import { TimelineMax, Expo } from 'gsap'

const transition = (fromMenu, callback) => {
  const tl = new TimelineMax({
    delay: fromMenu ? 0.8 : 0,
    onComplete: callback
  })

  tl
    .to('#smoothie', 1.2, {
      y: 100,
      autoAlpha: 0,
      ease: Expo.easeInOut
    })

  return tl
}

export default transition



// WEBPACK FOOTER //
// ./src/scripts/transitions/fadeOut.js